/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import ConnectionItem from './ConnectionItem';

const ConnectionList = ({ connections }) => {
  if (connections.length === 0) {
    return <p>No active connections.</p>;
  }

  return (
    <div>
      {connections.map((connection, index) => (
        <ConnectionItem key={connection.channel_name || index} connection={connection} />
      ))}
    </div>
  );
};

export default ConnectionList;
